/**
 * Contourist feature band — home page.
 *
 * A working mini-configurator: picking a place, garment colour or ink
 * redraws the previews in place. Nothing is added to cart here; every CTA
 * routes to the full configurator carrying the current selection, so the
 * visitor arrives already looking at what they just built.
 *
 * The tee and poster artwork is NOT drawn here -- it comes from
 * window.CxPreview, the same renderer assets/contourist.js uses for the
 * configurator, so both pages share one contour dataset and one ink rule.
 */
(function () {
  "use strict";

  var root = document.querySelector('[data-cf]');
  if (!root || !window.CxPreview) return;

  var TOPO_URL = root.getAttribute('data-topo-url');
  var CONFIG_URL = root.getAttribute('data-configurator-url') || '';
  var TEE_IMAGES = parseJSON(root.getAttribute('data-tee-images')) || {};

  // Gradient stops, only needed for the ink whose colours aren't derived
  // from the paper: Ember (duo) and Spectrum (which the configurator calls
  // 'rainbow') are toned by the shared renderer against the fabric. The
  // place, garment and ink names live in the section markup, so they are
  // editable content rather than being spelled a second time here.
  var INK_STOPS = { custom: { from: '#6b3fa0', to: '#f2a0c8' } };

  // One card per paper colour, alternating palettes, so the row doubles as
  // a colour range.
  var EXAMPLES = [
    { id: 'fuji', palette: 'duo', paper: '#e7e3da' },
    { id: 'mont_blanc', palette: 'rainbow', paper: '#444444' },
    { id: 'machu_picchu', palette: 'duo', paper: '#cab698' },
    { id: 'kilimanjaro', palette: 'rainbow', paper: '#546070' }
  ];

  var TITLE = 'STILL PEAKING.';
  var EDITION = '1 / 1';
  var DENSITY = 15;

  var state = { loc: 'popo_izta', garment: '#444444', ink: 'duo' };
  var DATA = null;

  function parseJSON(raw) {
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function artOpts() {
    var stops = INK_STOPS[state.ink] || {};
    return {
      title: TITLE, message: '', edition: EDITION, date: '',
      density: DENSITY, from: stops.from || '#e0160a', to: stops.to || '#edb85a'
    };
  }

  /* previews */
  function renderPreviews() {
    if (!DATA || !DATA[state.loc]) return;
    var opts = artOpts();

    var tee = root.querySelector('[data-cf-tee]');
    if (tee) tee.innerHTML = window.CxPreview.teeFragment(state.loc, state.ink, state.garment, opts, TEE_IMAGES[state.garment] || null);

    var poster = root.querySelector('[data-cf-poster]');
    if (poster) {
      poster.innerHTML = window.CxPreview.posterCard(state.loc, state.ink, Object.assign({}, opts, { paper: state.garment }));
    }
    renderCaption();
  }

  // Elevation and coordinates come from the traced dataset itself, so the
  // figures here can never drift from what the configurator shows.
  function renderCaption() {
    var loc = DATA[state.loc];
    var meta = window.CxPreview.meta[state.loc] || {};
    setText('[data-cf-region]', meta.region || loc.country || '');
    setText('[data-cf-name]', loc.label || '');
    setText('[data-cf-elev]', Math.round(loc.zmax).toLocaleString('en-US') + ' m');
    setText('[data-cf-coord]', window.CxPreview.fmtCoords(loc.center, true));
  }

  // The printed title is the short display name the card is captioned with,
  // uppercased with a full stop -- the dataset's own labels ("Machu Picchu /
  // Andes") run long inside a poster. The section markup owns those names,
  // so they aren't spelled twice.
  function renderExamples() {
    if (!DATA) return;
    root.querySelectorAll('[data-cf-example]').forEach(function (el) {
      var id = el.getAttribute('data-cf-example');
      var ex = EXAMPLES.filter(function (e) { return e.id === id; })[0];
      if (!ex || !DATA[id]) return;
      var name = el.getAttribute('data-cf-example-title') || '';
      el.innerHTML = window.CxPreview.posterCard(id, ex.palette, {
        title: name.toUpperCase() + '.',
        message: '', edition: EDITION, date: '',
        density: DENSITY, from: '#e0160a', to: '#edb85a', paper: ex.paper
      });
    });
  }

  function setText(sel, value) {
    root.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
  }

  function syncPressed() {
    root.querySelectorAll('[data-cf-place]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cf-place') === state.loc ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cf-garment]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cf-garment') === state.garment ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cf-ink]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cf-ink') === state.ink ? 'true' : 'false');
    });
    syncLinks();
  }

  // Every route out of this section carries the current selection, so the
  // configurator opens on what the visitor just built.
  function syncLinks() {
    if (!CONFIG_URL) return;
    var q = '?loc=' + encodeURIComponent(state.loc) + '&style=' + encodeURIComponent(state.ink);
    root.querySelectorAll('[data-cf-configure]').forEach(function (a) {
      a.setAttribute('href', CONFIG_URL + q);
    });
    root.querySelectorAll('[data-cf-configure-search]').forEach(function (a) {
      a.setAttribute('href', CONFIG_URL + q + '&focus=search');
    });
  }

  /* wiring */
  function wire() {
    root.querySelectorAll('[data-cf-place]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.loc = btn.getAttribute('data-cf-place');
        syncPressed();
        renderPreviews();
      });
    });
    root.querySelectorAll('[data-cf-garment]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.garment = btn.getAttribute('data-cf-garment');
        syncPressed();
        renderPreviews();
      });
    });
    root.querySelectorAll('[data-cf-ink]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.ink = btn.getAttribute('data-cf-ink');
        syncPressed();
        renderPreviews();
      });
    });

    // An example card loads that place into the live preview above. The
    // stage is higher up the page, so scroll back to it -- otherwise the
    // change happens off-screen and reads as a dead click.
    root.querySelectorAll('[data-cf-example-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        state.loc = card.getAttribute('data-cf-example-card');
        syncPressed();
        renderPreviews();
        scrollToEl(root.querySelector('[data-cf-stage]'));
      });
    });

    root.querySelectorAll('[data-cf-see-examples]').forEach(function (btn) {
      btn.addEventListener('click', function () { scrollToEl(root.querySelector('[data-cf-examples]')); });
    });
  }

  function scrollToEl(el) {
    if (!el) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
  }

  /* boot.
     The contour dataset is a few hundred KB, which isn't worth spending on
     a home page nobody has scrolled to yet -- so it loads once the band is
     within a screen of the viewport, and the frames hold skeletons until it
     lands. A plain rect check on scroll rather than an IntersectionObserver:
     it's less code, and it's synchronous, so a band that's already on screen
     at load starts fetching immediately instead of waiting for a callback
     that a backgrounded page may never deliver. */
  var started = false;

  function maybeStart() {
    if (started) return;
    // A viewport height of 0 means there isn't a laid-out one to measure
    // against (prerender, a backgrounded renderer): render rather than sit
    // on skeletons forever, since the point of the gate is only to defer
    // the fetch, never to skip it.
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var r = root.getBoundingClientRect();
    if (vh > 0 && (r.top > vh + 400 || r.bottom < -400)) return;
    started = true;
    window.removeEventListener('scroll', maybeStart);
    window.removeEventListener('resize', maybeStart);
    window.CxPreview.load(TOPO_URL)
      .then(function (data) {
        DATA = data;
        renderPreviews();
        renderExamples();
      })
      .catch(function (err) {
        // Skeletons stay put -- better a quiet placeholder than an empty
        // product frame on the home page.
        console.error('[Contourist feature]', err.message);
      });
  }

  wire();
  syncPressed();
  window.addEventListener('scroll', maybeStart, { passive: true });
  window.addEventListener('resize', maybeStart, { passive: true });
  maybeStart();
})();
